import { render, staticRenderFns } from "./FormMetadataProfiling.vue?vue&type=template&id=4b15b7d3&lang=pug"
import script from "./FormMetadataProfiling.vue?vue&type=script&lang=js"
export * from "./FormMetadataProfiling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b15b7d3')) {
      api.createRecord('4b15b7d3', component.options)
    } else {
      api.reload('4b15b7d3', component.options)
    }
    module.hot.accept("./FormMetadataProfiling.vue?vue&type=template&id=4b15b7d3&lang=pug", function () {
      api.rerender('4b15b7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormMetadataProfiling.vue"
export default component.exports